const brand = Object.freeze({
  name: "Sistemik Seguros",
  shortName: "Sistemik",
  productName: "Gestión de seguros",
  description: "CRM para productores y organizaciones de seguros.",
  locale: "es-AR",
  assets: {
    logo: "brand/logo.svg",
    mark: "brand/mark.svg",
    favicon: "brand/favicon.svg",
  },
  theme: {
    primary: "#111827",
    secondary: "#475569",
    accent: "#2563EB",
  },
});

module.exports = brand;
